import { Button, TableCell, TableRow, TableSortLabel } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

export const CustomTableRow = withStyles(() => ({
    root: {
        height: '30px !important',
    }
}))(TableRow)

export const CustomTableRowSeparator = withStyles(() => ({
    root: {
        height: '5px !important',
    }
}))(TableRow)

export const CustomEmptyTableCell = withStyles(() => ({
    head: {
        backgroundColor: '#0A1F2E',
        //color: theme.palette.common.white,
        color: 'white',
        width: 50,
        borderBottom: '0px',
    },
    root: {
        padding: '0px 8px 0px 10px',
    }
}))(TableCell)

export const CustomTableHeaderCell = withStyles(() => ({
    root: {
        padding: "0px 10px",
        height: 20,
    },
    head: {
        backgroundColor: '#0A1F2E',
        //color: theme.palette.common.white,
        color: 'white',
        borderBottom: '0px',
        fontWeight: 500,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell)

export const CustomTableCell = withStyles(() => ({
    root: {
        padding: "0px 5px",
        height: 20,
    },
    head: {
        backgroundColor: '#0A1F2E',
        //color: theme.palette.common.white,
        color: 'white',
        width: 86,
        borderBottom: '0px',
        fontWeight: 500,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell)

export const CustomTableSortLabel = withStyles(() => ({
    root: {
        color: 'white !important',
    },
    icon: {
        color: 'white !important'
    }
}))(TableSortLabel)

// export const CustomTableSortLabel = (props) => {
//     const { active, direction, onClick, children, hideIcon, align } = props

//     const icon = (
//         <ArrowDownward
//             fontSize="small"
//             style={{ transform: direction === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)', color: 'white'}}
//         />
//     );
//     return (
//         <div
//             onClick={onClick}
//             display="flex"
//             alignItems="center"
//             justifyContent={align === 'right' ? 'flex-end' : 'flex-start'}
//             sx={{ cursor: 'pointer' }}
//         >
//             {align === 'left' && !hideIcon && active && icon}
//             <TableSortLabel
//                 active={active}
//                 direction={direction}
//                 hideSortIcon
//                 sx={{ opacity: 1 }}
//             >
//                 {children}
//             </TableSortLabel>
//             {align === 'right' && !hideIcon && active && icon}
//         </div>
//     );
// }

export const CustomTableCellInput = withStyles(() => ({
    root: {
        padding: '4px 5px',
        borderBottom: '1px solid #0A1F2E',
    },
    head: {
        backgroundColor: '#55758C',
        //color: theme.palette.common.white,
        color: 'white',
    },
    body: {
        fontSize: 14,
    }
}))(TableCell)

export const CustomTotalsTableCell = withStyles(() => ({
    root: {
        height: '5px',
        padding: "0px",
        borderBottom: '0px',
        backgroundColor: '#0A1F2E',
        color: 'white',
        fontWeight: 500,
        fontSize: 16,
    },
}))(TableCell)

export const CustomSelectedButton = withStyles(() => ({
    root: {
        padding: '0px 5px',
        fontWeight: 800,
        color: 'white',
        margin: '2px 0',
        height: '20px',
        width: 100,
        backgroundColor: '#4aaae1',
        '&:hover': {
            backgroundColor: '#94c5e1'
        }
    },
    label: {
        fontSize: 10
    },
    disabled: {
        backgroundColor: '#4aaae180'
    },
}))(Button)

export const CustomAdditionButton = withStyles(() => ({
    root: {
        padding: '0px 5px',
        fontWeight: 700,
        color: 'white',
        marginTop: '5px',
        height: '20px',
        width: 90,
        backgroundColor: '#4aaae1',
        '&:hover': {
            backgroundColor: '#94c5e1'
        }
    },
    disabled: {
        backgroundColor: '#4aaae180',
    }
}))(Button)
